var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CoTippy',{attrs:{"text":_vm.size === 'small' ? _vm.$t('matchtooltipmobile') : _vm.$t('matchtooltip')}},[_c('div',{staticClass:"co-match d-flex align-items-center",class:( _obj = {}, _obj[_vm.size] = true, _obj )},[_c('CoIcon',{attrs:{"name":"custom-png-star"}}),(_vm.size !== 'small')?_c('div',{staticClass:"mx-auto"},[_vm._v(_vm._s(_vm.score)+"% match")]):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }